// 地铁配置

// 地铁线路名称映射（用于显示简称）
export const subwayName = {
  机场轨道快线: "机场",
  "1号线": "1",
  "2号线": "2",
  "3号线": "3",
  "4号线": "4",
  "5号线": "5",
  "6号线": "6",
  "7号线": "7",
  "8号线": "8",
  "9号线": "9",
  "10号线": "10",
  "16号线": "16",
  "19号线": "19",
  "1号线延长": "1",
  "2号线延长": "2",
  "3号线延长": "3",
  "4号线延长": "4",
  "5号线延长": "5",
  "6号线延长": "6",
  "9号线延长": "9",
  "10号线延长": "10",
  "11号线": "11",
  "12号线": "12",
  "14号线": "14",
  "15号线": "15",
  "13号线": "13",
  "18号线": "18",
  "21号线": "21",
  "绍兴1号线": "绍1",
  "绍兴2号线": "绍2",
  "绍1号线": "绍1",
  "绍2号线": "绍2",
  杭绍线: "绍1",
  杭绍城际: "绍1",
  杭绍城际线: "绍1",
}

// 地铁线路颜色
export const subwayColor = {
  机场轨道快线: "#c2272d",
  杭富线: "#67a2ca",
  "1号线": "#fe0000",
  "2号线": "#f15a25",
  "3号线": "#fbb03b",
  "4号线": "#8cc63e",
  "5号线": "#2aabe4",
  "6号线": "#0071bd",
  "6号线支线": "#0071bd",
  "7号线": "#ff0095",
  "8号线": "#ad70f9",
  "9号线": "#febe7e",
  "10号线": "#00f0f1",
  "16号线": "#bf526c",
  "1号线支线": "#fe0000",
  "3号线支线": "#fbb03b",
  "19号线": "#A5BAD6",
  "2号线延长": "#f15a25",
  "3号线延长": "#fbb03b",
  "4号线延长": "#8cc63e",
  "5号线延长": "#2aabe4",
  "6号线延长": "#0071bd",
  "9号线延长": "#febe7e",
  "10号线延长": "#00f0f1",
  "11号线": "#628a1a",
  "12号线": "#005f71",
  "14号线": "#666e9f",
  "15号线": "#a9a8a4",
  "13号线": "#e0c800",
  "18号线": "#c69c6c",
  "21号线": "#2267a0",
  "绍兴1号线": "#c5003e",
  "绍兴2号线": "#307fe2",
  "绍1号线": "#c5003e",
  "绍2号线": "#307fe2",
  杭绍线: "#c5003e",
  杭绍城际: "#c5003e",
  杭绍城际线: "#c5003e",
}

// 地铁线路状态（实线/虚线）
export const subwayStatus = {
  机场轨道快线: "dashed",
  杭富线: "dashed",
  "1号线": "solid",
  "2号线": "solid",
  "3号线": "solid",
  "4号线": "solid",
  "5号线": "solid",
  "6号线": "solid",
  "7号线": "solid",
  "8号线": "solid",
  "9号线": "solid",
  "10号线": "solid",
  "16号线": "solid",
  "1号线支线": "solid",
  "3号线支线": "solid",
  "19号线": "solid",
}

// 地铁线路列表
export const sublines = [
  "机场轨道快线",
  "1号线",
  "2号线",
  "3号线",
  "4号线",
  "5号线",
  "6号线",
  "7号线",
  "8号线",
  "9号线",
  "10号线",
  "11号线",
  "12号线",
  "14号线",
  "15号线",
  "16号线",
  "13号线",
  "18号线",
  "19号线",
]

export default {
  subwayName,
  subwayColor,
  subwayStatus,
  sublines
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/config/subwayConfig.js